import fetcher from '../fetcher';

const subscribeToken = async (token) => {
  const response = await fetcher.post('/salesman/subscribe-token', { token });
  return response;
};

export default subscribeToken;
